import { FC } from 'react';
import { Box } from '@mui/material';

import { useCampaignPageContext } from '../../../../../hooks/Contexts/Pages/CampaignPageContext';
import { useUserContext } from '../../../../../hooks/Contexts/UserContext';
import Block from '../../../../../components/Block';
import TabPanel from '../../../../../components/TabPanel';

import CampaignPageTabs, { PAGE_TABS } from '../Tabs/CampaignPageTabs';
import CampaignPageAdGroupPageTab from '../Tab/CampaignPageAdGroupPageTab';
import CampaignPageChangeHistoryPageTab from '../Tab/CampaignPageChangeHistoryPageTab';
import CampaignPageCreativePageTab from '../Tab/CampaignPageCreativePageTab';
import CampaignPageOverviewPageTab from '../Tab/CampaignPageOverviewPageTab';
import CampaignFlightsPageTab from '../Tab/CampaignFlightsPageTab';
import CampaignPagePerformancePageTab from '../Tab/CampaignPagePerformancePageTab';

const LOON_AGENCY_ID = 1;

const CampaignPageTabPanels: FC = (): React.JSX.Element => {
    const { selectedTab, selectTab } = useCampaignPageContext();
    const { userContext } = useUserContext();

    return (
        <Box>
            <Block
                disableGutters
                sx={{
                    borderBottom: 1,
                    borderColor: 'divider',
                    px: 2,
                }}
            >
                <CampaignPageTabs value={selectedTab} onChange={selectTab} />
            </Block>

            <TabPanel index={PAGE_TABS.overview.slug} value={selectedTab}>
                <CampaignPageOverviewPageTab />
            </TabPanel>

            <TabPanel index={PAGE_TABS.flights.slug} value={selectedTab}>
                <CampaignFlightsPageTab />
            </TabPanel>

            <TabPanel index={PAGE_TABS['ad-groups'].slug} value={selectedTab}>
                <CampaignPageAdGroupPageTab />
            </TabPanel>

            <TabPanel index={PAGE_TABS.creatives.slug} value={selectedTab}>
                <CampaignPageCreativePageTab />
            </TabPanel>

            <TabPanel index={PAGE_TABS['change-history'].slug} value={selectedTab}>
                <CampaignPageChangeHistoryPageTab />
            </TabPanel>

            {(userContext.isAdmin() || userContext.agencyId === LOON_AGENCY_ID) && (
                <TabPanel index={PAGE_TABS.performance.slug} value={selectedTab}>
                    <CampaignPagePerformancePageTab />
                </TabPanel>
            )}
        </Box>
    );
};

export default CampaignPageTabPanels;
